export const breedPager = (itemsSelector, perPage) => {
    const items = document.querySelectorAll(itemsSelector);
    const itemCounter = items.length;
    let currentPage = 1;

    function viewItems(items, currentPage, perPage) {
        let iterator = 0;
        if (currentPage > 1) {
            iterator = (currentPage * perPage) - perPage;
        }

        const limit = (iterator + perPage) - 1;
        for (iterator; iterator <= limit; iterator++) {
            const item = items[iterator];
            if (item == undefined) {
                break;
            }

            item.classList.remove('hidden');
        }
    }

    const btnView = document.querySelector('.experts_btn--link--more');
    if (null !== btnView) {
        btnView.addEventListener('click', () => {
            currentPage++;
            if (currentPage * perPage >= itemCounter) {
                btnView.classList.add('hidden');
            }
            viewItems(items, currentPage, perPage);
        });
    }

    viewItems(items, currentPage, perPage);
}